export default "__VITE_ASSET__CsLOF30p__"